import t from"./decodeAdMetadata.js";const l=l=>{const o=null==l?void 0:l.split("?")[0],d=null==o?void 0:o.split("/")[8];return d?t(d):null};export{l as default};
